import { api, ReactQueryOptions, RouterInputs } from '@api'
import { staleTimeIndex } from '@specs/constants'

type optionsType = ReactQueryOptions['ArtistManager']['countToys']
type inputType = RouterInputs['ArtistManager']['countToys']

export const useArtistToyCount = (input: inputType, options?: optionsType) =>
    api.ArtistManager.countToys.useQuery(input, {
        queryKey: ['ArtistManager.countToys', input],
        staleTime: 60 * 60 * 1000 * staleTimeIndex, // 1 hour
        ...options,
    })
